var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 17 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 9V5.5c0-3-2.5-5.5-5.5-5.5S3 2.5 3 5.5V9H0v13h17V9zM4 5.5C4 3 6 1 8.5 1S13 3 13 5.5V9H4zM16 21H1V10h15z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 17v1.9h1V17c1.4-.3 2.2-1.6 1.9-2.9s-1.5-2.3-2.9-2-2.2 1.6-1.9 2.9c.2 1 .9 1.8 1.9 2m.5-4c.8 0 1.5.7 1.5 1.5S9.3 16 8.5 16 7 15.3 7 14.5 7.7 13 8.5 13"
})));
export default SvgLock;